<h1 mat-dialog-title>
  {{title}}
</h1>

<div mat-dialog-content>
  <p>{{message}}</p>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="onDismiss()">Nein</button>
  <button mat-raised-button color="primary" (click)="onConfirm()">Ja</button>
</div>
